/**
 * MfaSetupHero — left-panel content for AUTH-06 MFA Setup.
 *
 * "Two-Factor Authentication" subtitle + 3-line body copy pointing to
 * Google Authenticator / Authy. Figma frame 79:90 hero column.
 */
export function MfaSetupHero() {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-lg font-semibold text-[var(--text-primary)]">Two-Factor Authentication</p>
      <p className="text-base leading-relaxed text-[var(--text-secondary)]">
        Your account requires MFA.
        <br />
        Use Google Authenticator
        <br />
        or Authy to set it up.
      </p>
    </div>
  );
}
